import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { TaskUpdateRequest } from "../models/endpoints/tasks.model";

export const useUpdateTask = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (request: TaskUpdateRequest) => {
			return await EndpointsService.dataRetriever.updateTask(request);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["participants-tasks"] });
			queryClient.invalidateQueries({ queryKey: ["participants-tasks-count"] });
			// The Requires attention category badges (useTasksCountsByCategory).
			// Without this they kept their pre-resolve numbers until a reload.
			queryClient.invalidateQueries({ queryKey: ["participants-alerts-tasks-count"] });
		},
	});
};
